import { Group, Text } from '@mantine/core';
import { Fragment, type ReactNode } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import classes from './PageHeader.module.css';

export interface Crumb {
  label: string;
  to?: string;
}

/** White strip under the top bar: title, breadcrumb, page actions (Hub page-header pattern). */
export function PageHeader({
  title,
  crumbs = [],
  actions,
}: {
  title: string;
  crumbs?: Crumb[];
  actions?: ReactNode;
}) {
  return (
    <div className={classes.strip}>
      <h1 className={classes.title}>{title}</h1>
      {crumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className={classes.crumbs}>
          {crumbs.map((c, i) => (
            <Fragment key={`${c.label}-${i}`}>
              {i > 0 && <FiChevronRight size={14} aria-hidden className={classes.sep} />}
              {c.to ? (
                <Link to={c.to}>{c.label}</Link>
              ) : (
                <Text span inherit className={classes.current} aria-current="page">
                  {c.label}
                </Text>
              )}
            </Fragment>
          ))}
        </nav>
      )}
      {actions && (
        <Group gap="xs" ms="auto" wrap="nowrap">
          {actions}
        </Group>
      )}
    </div>
  );
}

/** Standard page body gutter. */
export function PageBody({ children }: { children: ReactNode }) {
  return <div className={classes.body}>{children}</div>;
}
